"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = maxCopiesForPrintableGroup;
const either_1 = require("./../../types/either");
const PrintableGroup_1 = require("./../../models/printables/PrintableGroup");
function maxCopiesForPrintableGroup(targetGroupId, projectGroups) {
  // Pull the target group out of the list for convenience
  const targetGroup = projectGroups.find(x => x.id === targetGroupId);
  // Ensure targetGroup is included in the list of printable groups
  if (!targetGroup) {
    return (0, either_1.left)(new Error(`Could not find printable group with id '${targetGroupId}' in the given list.`));
  }
  // maximum number of copies is current number of copies + number of empty printable groups that have a copy
  return (0, either_1.right)(targetGroup.qty + projectGroups.filter(pg => pg.id !== targetGroupId && (0, PrintableGroup_1.isPrintableGroupEmpty)(pg) && pg.qty > 0).length);
}